import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "src/app/model/auth-model/auth.service";
import SystemConstants from "../constants/SystemConstants";
import { LocalizationService } from "../service/internationalization/localization.service";
import { Translations } from "../service/internationalization/translations.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService,
        private translations: Translations,
        private localizationService: LocalizationService,
        private toastrService: ToastrService){}

    intercept(request: HttpRequest<any>,
              next: HttpHandler) : Observable<HttpEvent<any>> {

        return next.handle(request)
        .pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMsg = '';
                if (error.error instanceof ErrorEvent) {
                    console.log(SystemConstants.CLIENT_SIDE_API_ERROR);
                    errorMsg = `${SystemConstants.ERROR_MSG} : ${error.error.message}`;
                }
                else {
                    console.log(SystemConstants.CLIENT_SIDE_API_ERROR);
                    errorMsg = `${SystemConstants.ERROR_CODE} : ${error.status}, ${SystemConstants.MESSAGE}: ${error.message}`;
                    if(error.error.status === SystemConstants.TOKEN_EXPIRED_STATUS) {
                        this.authService.logout()
                        // this.localizationService.displayToastrError(this.toastrService, this.translations.GLOBAL.ERROR_MESSAGES.TOKEN_EXPIRED)
                    }
                }
                return throwError(errorMsg);
            })
        )
    }
}